import React from 'react';
import { Link } from 'react-router-dom';
import { BadgeCheck } from 'lucide-react';

const PageHeader = ({ eyebrow, title, description, breadcrumb }) => {
  return (
    <section className="relative pt-32 md:pt-40 pb-16 md:pb-24 px-3 md:px-6">
      <div className="squiggle-bg" />
      <div className="max-w-[1400px] mx-auto">
        <div className="hero-frame relative overflow-hidden px-6 md:px-14 py-14 md:py-20 text-center">
          <div className="absolute inset-0 pointer-events-none opacity-60">
            <div className="absolute -top-24 -right-24 w-[400px] h-[400px] rounded-full blob-decor" />
            <div className="absolute -bottom-32 -left-24 w-[380px] h-[380px] rounded-full blob-decor" />
          </div>
          <div className="relative">
            {eyebrow && (
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-[#143324]/15 bg-white/60 text-[11px] tracking-[0.18em] uppercase text-[#143324] font-body mb-6">
                <BadgeCheck size={14} strokeWidth={1.8} />
                {eyebrow}
              </div>
            )}
            <h1 className="font-serif-display text-[#111111] leading-[1.02] text-[44px] sm:text-[56px] md:text-[68px] lg:text-[76px] tracking-[-0.02em] max-w-4xl mx-auto">
              {title}
            </h1>
            {description && (
              <p className="mt-6 text-[#3d3d3d] max-w-2xl mx-auto text-[15px] md:text-[16px] leading-relaxed font-body">
                {description}
              </p>
            )}
            {breadcrumb && (
              <nav className="mt-8 text-[13px] text-[#3d3d3d] font-body">
                <Link to="/" className="hover:text-[#143324]">Home</Link>
                <span className="mx-2">/</span>
                <span className="text-[#143324]">{breadcrumb}</span>
              </nav>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageHeader;
